import { createFileRoute } from "@tanstack/react-router";
import { TermsOfUse } from "@/lib/lazyPages";
import { SEO } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/terms-of-use")({
  head: () => seoHead(SEO.termsOfUse),
  component: TermsOfUse,
});
